import { QUERY_STRING_STORE } from '@/helpers/constants';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import AirQualityHistory from './AirQualityHistory';
import AirQualityNow from './AirQualityNow';
import { fetchSensorDataThreshold } from './AirQualityNow/query-request';
import './AirQuality.less';

@connect(state => ({
  querystring: state.querystring,
  sessionStore: state.session,
}))
class AirQuality extends Component {
  constructor(props) {
    super(props);
    this.state = {
      floor:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_FLOOR]?.[0],
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      tabActiveIndex: 0,
      sensorDataThreshold: [],
    };
  }

  componentDidMount() {
    const { floor } = this.state;
    if (floor) {
      this.getSensorDataThreshold({
        floor,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { querystring } = this.props;
    const { querystring: prevQuerystring } = prevProps;
    const floor = querystring?.[QUERY_STRING_STORE.SELECT_BOX_FLOOR]?.[0];
    const prevFloor =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_FLOOR]?.[0];
    const isFloorChanged = floor !== prevFloor;
    if (isFloorChanged) {
      this.setState({ floor }, () => {
        this.getSensorDataThreshold({
          floor,
        });
      });
    }
  }

  getSensorDataThreshold = async ({ floor }) => {
    let sensorDataThresholdRes = await fetchSensorDataThreshold({
      floorId: floor,
    });
    sensorDataThresholdRes = sensorDataThresholdRes?.[0] ?? [];
    this.setState({ sensorDataThreshold: sensorDataThresholdRes });
  };

  tabHeaderTemplate = options => {
    const icon =
      options.titleElement.props.children === 'NOW'
        ? 'pi pi-clock'
        : 'pi pi-history';
    const label =
      options.titleElement.props.children === 'NOW' ? '現在' : '履歴';
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className={`pi ${icon} mr-2`} />
        {label}
      </button>
    );
  };

  render() {
    const { tabActiveIndex, floor, sensorDataThreshold } = this.state;
    return (
      <div className="air-quality-container">
        <div className="air-quality-header">
          <div className="tab-menu">
            <button
              className={`tab-btn${tabActiveIndex === 0 ? ' selected' : ''}`}
              onClick={() => this.setState({ tabActiveIndex: 0 })}
              type="button"
            >
              現在
            </button>
            <button
              className={`tab-btn${tabActiveIndex === 1 ? ' selected' : ''}`}
              onClick={() => this.setState({ tabActiveIndex: 1 })}
              type="button"
            >
              履歴
            </button>
          </div>
        </div>

        <div className="air-quality-content-wrapper">
          {tabActiveIndex === 0 && (
            <AirQualityNow
              sensorDataThreshold={sensorDataThreshold}
              floor={floor}
            />
          )}
          {tabActiveIndex === 1 && (
            <AirQualityHistory
              sensorDataThreshold={sensorDataThreshold}
              floor={floor}
            />
          )}
        </div>
      </div>
    );
  }
}

AirQuality.propTypes = {};

export default AirQuality;
